const Endpoint = {
  SHOULD_SHOW_LEGACY_ALARM_MESSAGE: '/default/beamer-filter/should-show-legacy-alarm-message',
};

export default Endpoint;
